import { render, staticRenderFns } from "./model1Swiper.vue?vue&type=template&id=5a1992a6&scoped=true"
import script from "./model1Swiper.vue?vue&type=script&lang=js"
export * from "./model1Swiper.vue?vue&type=script&lang=js"
import style0 from "./model1Swiper.vue?vue&type=style&index=0&id=5a1992a6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a1992a6",
  null
  
)

export default component.exports